export default ($httpProvider) => {
  'ngInject';

  const interceptor = ['$q', '$location', '$injector', ($q, $location, $injector) => {
    return {
      response: response => response,
      responseError: rejection => {
        const $auth = $injector.get('$auth');

        try {
          // skip cancelled requests https://glebbahmutov.com/blog/catch-all-errors-in-angular-app/
          if (rejection.status) {
            // TODO need to pay
            /*Sentry.captureException(new Error("Http response error " +  rejection.status), {
                extra: {
                    Response: rejection.data,
                    Config: rejection.config,
                    Status: rejection.status
                }
            });*/
          }
        } catch (e) {
          console.error(e.stack)
        }

        const status = rejection.status;
        const redirect = encodeURIComponent($location.url());

        if ((status === 503 || status === 502) && $location.path() !== '/maintenance') {
          $location.path('/maintenance').search({redirect: redirect});
        } else if (status === 401 && $auth.isLogin()
          && rejection.config.url !== '/api/v1/oauth2/revoke' && $location.path() !== '/login') {
          const deferred = $q.defer();
          $auth.refreshToken(response => {
              const $http = $injector.get('$http');
              const config = rejection.config;
              config.headers['Authorization'] = response.token_type + ' ' + response.access_token;
              $http(config)
                .then(resp => deferred.resolve(resp),
                  resp => {
                    deferred.reject(resp);
                    if ($location.path() !== '/login') {
                      $location.path('/login').search({redirect: redirect});
                    }
                  });
            },
            response => {
              deferred.reject(response);
              if ($location.path() !== '/login') {
                $location.path('/login').search({redirect: redirect});
              }
            });
          return deferred.promise;
        }

        return $q.reject(rejection);
      }
    };
  }];
  $httpProvider.interceptors.push(interceptor);
  $httpProvider.useApplyAsync(true);
  $httpProvider.defaults.timeout = 5000;

}
